export default "__VITE_ASSET__6cd8a646__"